/** Four hundred and three: black flag, shown with the car number.
 *
 * For an account that is signed in and is not an admin, on a route that is
 * the owner's. It names the role the account holds and the one the page
 * wanted, because "you may not" with no reason is how a support thread
 * starts.
 *
 * "Switch account" signs out before it goes to the sign-in page. It has to:
 * that page sends a signed-in visitor straight back where they came from,
 * which would be here.
 */

import { Link } from 'react-router-dom';
import { FlagPage } from '@/components/ui/FlagPage';
import { useMe } from '@/lib/session';

function BlackFlag() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        height: '100%',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          background:
            'radial-gradient(ellipse 45% 55% at 50% 50%, color-mix(in srgb, var(--color-accent) 7%, transparent), transparent 70%)',
        }}
      />
      <div style={{ display: 'flex', alignItems: 'flex-start', position: 'relative' }}>
        <div
          style={{
            width: 4,
            height: 380,
            borderRadius: 2,
            background: 'linear-gradient(var(--color-neutral-500), var(--color-neutral-800))',
          }}
        />
        <div
          style={{
            width: 300,
            height: 220,
            marginTop: 6,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background:
              'linear-gradient(135deg, var(--color-neutral-900), var(--color-neutral-800) 60%, var(--color-neutral-900))',
            boxShadow: 'var(--shadow-lg)',
            borderRadius: '0 var(--radius-sm) var(--radius-sm) 0',
            transformOrigin: 'left center',
            animation: 'flagwave 3s ease-in-out infinite',
          }}
        >
          <div
            className="tabular-nums"
            style={{
              width: 110,
              height: 110,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'var(--color-neutral-200)',
              color: 'var(--color-neutral-900)',
              fontSize: 44,
              letterSpacing: '-0.03em',
            }}
          >
            403
          </div>
        </div>
      </div>
    </div>
  );
}

export function Forbidden({ required = 'admin' }: { required?: string }) {
  const { me, signOut } = useMe();

  return (
    <FlagPage
      status={403}
      swatch="flag-swatch-black"
      kicker="Black flag · car #403"
      title="Report to the stewards. This area is admin only."
      actions={
        <>
          <Link className="btn btn-primary" to="/sessions">
            Back to my sessions
          </Link>
          <button type="button" className="btn btn-secondary" onClick={() => void signOut('/signin')}>
            Switch account
          </button>
        </>
      }
      diag={
        <>
          role: {me?.user.role ?? 'signed out'} · required: {required}
        </>
      }
      art={<BlackFlag />}
    >
      Your account is signed in, but it doesn't hold the role this page needs. If you think it
      should, the platform owner can grant it.
    </FlagPage>
  );
}

export default Forbidden;
